import React from "react"
import PropTypes from "prop-types"
import { Table, Column, Button } from "@tencent/spaui"
import IndustryInfo from "@/business-components/sale/IndustryInfo"
import AreaInfo from "@/business-components/sale/AreaInfo"
import PromotedObjectInfo from "@/business-components/sale/PromotedObjectInfo"
import ExternalLink from "@/components/ExternalLink"
import MpOpenInfo from "@/components/MpOpenInfo"
import ContactListView from "./ContactListView"

class SupplementaryPanel extends React.Component {
  static propTypes = {
    lead: PropTypes.shape({
      leadId: PropTypes.number.isRequired,
      company: PropTypes.shape({
        companyName: PropTypes.string.isRequired,
        industryId: PropTypes.number.isRequired,
        areaId: PropTypes.number.isRequired,
        address: PropTypes.string,
      }).isRequired,
      intention: PropTypes.shape({
        adPlatformType: PropTypes.string.isRequired,
        promotedObject: PropTypes.string,
      }),
      memo: PropTypes.string,
      customerId: PropTypes.number,
      customerMpUserName: PropTypes.string,
      customerUnibdAppId: PropTypes.string,
    }).isRequired,
    contactList: PropTypes.array,
  }

  render() {
    const {
      lead: { leadId, company = {}, intention, memo },
      contactList,
      dataKey,
    } = this.props

    return (
      <div className="CustomerPanel">
        <h2>增补信息 {dataKey + 1}</h2>
        <h4>
          公司名称：{company.companyName} <IndustryInfo industryId={company.industryId} />
        </h4>
        <dl>
          {/* <dt>账户 ID：</dt>
          <dd>{customerUnibdAppId?customerUnibdAppId:(customerMpUserName ? customerMpUserName : customerId)}</dd> */}
          <dt>公司地址：</dt>
          <dd>
            <AreaInfo areaCode={company.areaId} /> {company.address}
          </dd>
          <dt>线索 ID：</dt>
          <dd>{leadId}</dd>
          <dt>公司官网：</dt>
          <dd>
            <ExternalLink href={company.homepageUrl} />
          </dd>
          <dt>推广目标：</dt>
          <dd>
            <PromotedObjectInfo promotedObject={intention} />
          </dd>
          <dt>公众号名称：</dt>
          <dd>
            {company.mpOpenName}
            {/* <MpOpenInfo mpOpenName={company.mpOpenName} /> */}
          </dd>
          <dt>备注信息：</dt>
          <dd>
            <div>{memo}</div>
          </dd>
        </dl>
        <h2>联系人</h2>
        <ContactListView lead={this.props.lead} leadId={leadId} contactList={contactList} readOnly={true} />
      </div>
    )
  }
}

export default SupplementaryPanel
